export function accMul(arg1, arg2){
   //js 乘法函数
  //调用：accMul(arg1,arg2)
  //返回值：arg1乘以arg2的精确结果
   
    var m = 0,
      s1 = arg1.toString(),
      s2 = arg2.toString();
    try {
      m += s1.split(".")[1].length;
    } catch (e) {
        console.log(e)
    }
    try {
      m += s2.split(".")[1].length;
    } catch (e) {
        console.log(e)
    }
    return (
      (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
      Math.pow(10, m)
    );
  
}